// Responsive
GLOBAL.windowSize = {};

GLOBAL.responsive = () => {
  // May include scrollbars sizes
  GLOBAL.windowSize.width = document.documentElement.clientWidth;
  GLOBAL.windowSize.height = document.documentElement.clientHeight;

  // Set CSS variable to correct window height calculation for mobile browsers
  const vh = GLOBAL.windowSize.height * .01;

  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // If changed only window height
  GLOBAL.onlyWindowHeightChanged = false;
  if (GLOBAL.windowSize.previousWidth == GLOBAL.windowSize.width) {
    GLOBAL.onlyWindowHeightChanged = true;
  }
  GLOBAL.windowSize.previousWidth = GLOBAL.windowSize.width;
}


window.addEventListener('DOMContentLoaded', () => {

  // Useful classes for responsive design
  const html = document.querySelector('html');

  html.classList.remove('no-js');
  html.classList.add(GLOBAL.isTouchscreen ? 'isTouchscreen' : 'isDesktop');

  // Make responsive
  GLOBAL.responsive();


  // Header toggle
  const headerToggle = () => {
    const header = document.querySelector('header');

    if (!header) {
      return;
    }
    if (document.documentElement.scrollTop > parseFloat(window.getComputedStyle(header, null).getPropertyValue('padding-top'))) {
      header.classList.add('hide');
    } else {
      header.removeAttribute('class');
    }
  }
  headerToggle();
  window.addEventListener('scroll', () => {
    headerToggle();
  });

  // Open projects
  document.querySelectorAll('.projects-more:not(.external)').forEach((link) => {
    link.addEventListener('click', (event) => {
      const main = link.parentNode.parentNode,
            target = main.nextElementSibling;

      if (target) {
        event.preventDefault();

        if (!link.classList.contains('active')) {
          link.classList.add('active');
          target.classList.add('opened');
          window.scrollTo({
            top: target.offsetTop - 100,
            left: 0,
            behavior: 'smooth'
          });
        } else {
          link.classList.remove('active');
          target.classList.remove('opened');
          window.scrollTo({
            top: main.offsetTop,
            left: 0,
            behavior: 'smooth'
          });
        }
      }
    });
  });

  // Galleries
  document.querySelectorAll('.projects-content .gallery').forEach((gallery) => {
    const gallerySwiper = new Swiper(gallery.querySelector('.swiper'), {
      autoHeight: true,
      loop: true,
      pagination: {
        el: gallery.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true
      },
      on: {
        init: () => {
          gallery.querySelector('.swiper-wrapper').addEventListener('click', () => {
            gallerySwiper.slideNext();
          });
        }
      }
    });
  });

}, false);


window.addEventListener('resize', () => {

  // Make responsive
  GLOBAL.responsive();

}, false);


window.addEventListener('load', () => {

  // Make responsive
  GLOBAL.responsive();

}, false);